var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgViewGreen = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32817_63427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.49976 7.76953C6.47646 7.76953 7.27002 6.97597 7.27002 5.99928C7.27002 5.02258 6.47646 4.22902 5.49976 4.22902C4.52307 4.22902 3.72951 5.02258 3.72951 5.99928C3.72951 6.97597 4.52307 7.76953 5.49976 7.76953ZM5.63406 6.52425C5.85382 6.52425 6.03694 6.34112 6.03694 6.12136L6.62296 6.12136C6.61075 6.67075 6.17124 7.11026 5.63406 7.11026L5.63406 6.52425Z",
    fill: "#17C653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.128191 6.36481C0.726415 7.10954 2.86293 9.53906 5.5 9.53906C8.13707 9.53906 10.2736 7.10954 10.8718 6.36481C11.0427 6.15726 11.0427 5.85205 10.8718 5.63229C10.2736 4.88756 8.13707 2.45804 5.5 2.45804C2.86293 2.45804 0.726415 4.88757 0.128191 5.63229C-0.0427297 5.83984 -0.0427297 6.14506 0.128191 6.36481ZM5.5 3.43473C6.9162 3.43473 8.06382 4.58235 8.06382 5.99855C8.06382 7.41476 6.9162 8.56237 5.5 8.56237C4.0838 8.56237 2.93618 7.41476 2.93618 5.99855C2.93618 4.58235 4.0838 3.43473 5.5 3.43473Z",
    fill: "#17C653"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32817_63427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(11 11.5) rotate(180)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgViewGreen);
export default ForwardRef;